import { Paragraph, TextRun, PageBreak } from 'docx'

const TableOfContentsPage = () => [
  new Paragraph({ children: [new PageBreak()] }),
  new Paragraph({
    children: [
      new TextRun({
        text: '目錄',
        bold: true,
        font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
        size: 52,
      }),
    ],
  }),
  new Paragraph(''),
]

export default TableOfContentsPage
